var bodyScrolledTrigger = 130,
    bodyScrolledTriggerMobile = 30,
    bodyScrollY = 0,
    mainMenuScrollY = 0,
    bodyScrollUpdateTicking = false,
    mainMenuScrollUpdateTicking = false,
    bodyScrolled = false,
    bodyScrolledMobile = false,
    mainMenuScrolled = false,
    mobileMenuActive = false,
    $main,
    $body,
    $menuBar,
    $mobileMenuToggle,
    $mainMenu,
    $timerElem,
    $toggleAccordion;

$(document).ready(function ($) {

    $body = $('body');
    $main = $('main');
    $menuBar = $("#menubar");
    $mobileMenuToggle = $("#mobile-menu-toggle");
    $mainMenu = $("#mainmenu");
    $timerElem = $(".js-timer");
    $toggleAccordion = $('.js-toggle-accordion');
    $pass1 = $('#pass1');
    $pass2 = $('#pass2');

    $(window).on('scroll', requestBodyScrollUpdate);
    requestBodyScrollUpdate();

    $mainMenu.on('scroll', requestMainMenuScrollUpdate);

    $toggleAccordion.on('click', function (e) {
        e.stopPropagation();
        var $parent = $(this).parent();
        if ($parent.hasClass('is-open')) {
            $parent.removeClass('is-open');
            $(this).next().stop().slideUp();
        } else {
            $toggleAccordion.parent().removeClass('is-open');
            $toggleAccordion.next().stop().slideUp();
            $parent.addClass('is-open');
            $(this).next().stop().slideDown();
        }
    });

    $mobileMenuToggle.click(function (e) {
        mobileMenuActive = !mobileMenuActive;
        $body.toggleClass('mobile-menu-active', mobileMenuActive);

        if (!mobileMenuActive) requestBodyScrollUpdate();
    });

    // Disable the 'repeat password' field on the reset password page.
    $pass1.on('keyup', function (e) {
        $pass2.val($pass1.val());
    });

    //Carousels    
    var $latestPostsBlock = $(".content-block-latestposts");

    if ($latestPostsBlock.length > 0 && window.innerWidth < 768) {
        $latestPostsBlock.each(function () {

            var $thisBlock = $(this);
            var $postsRow = $thisBlock.find('.posts-list-latest-posts');
            var $postsContainer = $thisBlock.find('.posts-list-latest-posts-container');


            $postsRow.removeClass('row').addClass('owl-carousel');

            $postsContainer.removeClass('container');

            $postsRow.find('.post-block-container').removeClass('col-md-4');
            $postsRow.owlCarousel({
                items: 1,
                margin: 15,
                stagePadding: 30,
                nav: false,
                responsive: {
                    0: {
                        items: 1,
                    },
                    540: {
                        items: 2,
                    }
                }

            });

        })
    }

    var $faders = $(".fader");

    if ($faders.length) {
        $faders.each(function () {
            var $thisFader = $(this);

            $thisFader.on('cycle-post-initialize', function (event, optionHash) {
                var currSlide = optionHash.slides[optionHash.currSlide];
                $(currSlide).addClass('enlarge');
            }).on('cycle-before', function (event, optionHash, outgoingSlideEl, incomingSlideEl, forwardFlag) {
                $(incomingSlideEl).addClass('enlarge');
            }).on('cycle-after', function (event, optionHash, outgoingSlideEl, incomingSlideEl, forwardFlag) {
                $(outgoingSlideEl).removeClass('enlarge');
            });

            $thisFader.cycle({
                speed: 5000,
                timeout: 5000,
                slides: '> div',
                fx: 'fade',
                log: false
            })

        });
    }

    if ($timerElem.length) {
        $timerElem.each(function () {
            var $timerElement = $(this).first();
            var countDownDate = new Date($timerElement.data('countdown')).getTime();
            updateCountdown($timerElement, countDownDate);

            var timerIntervalId = window.setInterval(function () {
                updateCountdown($timerElement, countDownDate, timerIntervalId);
            }, 1000);
        });
    }

    $('.p-market-card_card-container').click(function () {

        if($(this).hasClass('p-market-card_card-container__active')) {
            $('.p-market-card_card-container').removeClass('p-market-card_card-container__active');
            $('.p-market-card_content-container').removeClass('p-market-card_content-container__open');
        }
        else {
            $('.p-market-card_card-container').removeClass('p-market-card_card-container__active');
            $('.p-market-card_content-container').removeClass('p-market-card_content-container__open');
            $(this).addClass('p-market-card_card-container__active');
            $(this).next().addClass('p-market-card_content-container__open');

        }

    });

    $('.p-market-card__content-arrow').click(function(){
        var $marketID = $(this).attr('marketID');
        $("[contentID=" + $marketID + "]").removeClass('p-market-card_content-container__open');
        $("[marketID=" + $marketID + "]").removeClass('p-market-card_card-container__active');
    })

});

function updateCountdown($elem, countDownDate, timerIntervalId) {
    // Get today's date and time
    var now = new Date().getTime();

    // Find the distance between now and the count down date
    var distance = countDownDate - now;

    // If the count down is finished, write some text
    if (distance < 0) {
        clearInterval(timerIntervalId);
        $elem.remove();
        return;
    }

    // Time calculations for days, hours, minutes and seconds
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // Display the result in the element
    $elem.html(days + "d " + hours + "h " + minutes + "m " + seconds + "s ");

}


function requestBodyScrollUpdate() {

    bodyScrollY = window.scrollY;

    if (!bodyScrollUpdateTicking) {
        requestAnimationFrame(function () {
            bodyScrollUpdateTicking = false;

            var bodyCurrentlyScrolled = (bodyScrollY > bodyScrolledTrigger);
            if (bodyCurrentlyScrolled !== bodyScrolled) {
                bodyScrolled = bodyCurrentlyScrolled;
                $('body').toggleClass('scrolled', bodyScrolled);
            }

            if (!mobileMenuActive) {
                var mobileCurrentlyScrolled = (bodyScrollY > bodyScrolledTriggerMobile);
                if (mobileCurrentlyScrolled !== bodyScrolledMobile) {
                    bodyScrolledMobile = mobileCurrentlyScrolled;
                    $('body').toggleClass('scrolled-mobile', bodyScrolledMobile);
                }
            }

        });
    }
    bodyScrollUpdateTicking = true;
}


function requestMainMenuScrollUpdate() {

    mainMenuScrollY = $mainMenu.scrollTop();


    if (!mainMenuScrollUpdateTicking) {
        requestAnimationFrame(function () {
            mainMenuScrollUpdateTicking = false;

            var mainMenuCurrentlyScrolled = mainMenuScrollY > 0;

            if (mainMenuScrolled !== mainMenuCurrentlyScrolled) {
                mainMenuScrolled = mainMenuCurrentlyScrolled;
                $mainMenu.toggleClass('scrolled', mainMenuScrolled);
            }


        });
    }
    mainMenuScrollUpdateTicking = true;
}
